export enum ProcurementIntegrationType {
  Ariba = 'ARIBA',
}
